import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const NotificationWrapper = styled(motion.div)`
    color: ${({ theme }) => theme.shades.white['100']};
    background: ${({ theme }) => theme.colors.blue};

    @supports (backdrop-filter: blur(1px)) {
        background: ${({ theme }) => theme.shades.white['20']};
        backdrop-filter: blur(40px);
    }

    border-radius: 12px;
    z-index: 500;
    padding: 16px;
    position: fixed;
    bottom: 32px;
    display: flex;
    place-items: center;
    justify-content: space-between;
    column-gap: 20px;
    cursor: pointer;
    width: Min(80%, 360px);
    left: 50%;
`;

export const ContentWrapper = styled.div<{ $centered: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
    justify-content: center;
    flex-wrap: wrap;
    flex: 1 1 auto;
`;
